/*
 * LetUsHelpYou.jsx
 * Created by Destin Frasier on 05/02/18
 */

import React from 'react';
import { isEmpty } from 'lodash';

export default class LetUsHelpYou extends React.Component {
    render() {
        let knowledgeLink;

        if (!isEmpty(process.env.SN_KB_EXT_URL)) {
            knowledgeLink = (
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={process.env.SN_KB_EXT_URL}
                    aria-label="Help">
                    Help Center
                </a>
            )
        }

        return (
            <ul className="nav-footer-list">
                <li>
                    <a href="/account/profile">Your Account</a>
                </li>
                <li>
                    <a href="/account/reservations">Your Reservations</a>
                </li>
                <li className="contact-support">
                    <a href="/contact-us">Contact Us</a>
                </li>
                <li>
                    {knowledgeLink}
                </li>
                <li className="contact-support">
                    <a href="/feedback">Submit Feedback</a>
                </li>
            </ul>
        );
    }
}
